import useEvent from "react-use-event-hook";
import { useSetRecoilState } from "recoil";

import { Log } from "@ryde/shared";

import { useLandingApiProfile } from "../api";
import { isLoggedInLandingAtom, profileLandingDtoAtom } from "../atoms";

export const useLandingProfile = () => {
  const setProfileLandingDtoAtom = useSetRecoilState(profileLandingDtoAtom);
  const { getLandingProfile } = useLandingApiProfile();
  const setIsLoggedIn = useSetRecoilState(isLoggedInLandingAtom);

  const fetchAndSetProfile = useEvent(async (): Promise<void> => {
    const profile = await getLandingProfile();

    if (profile?.success && profile.data) {
      setProfileLandingDtoAtom(profile.data);
    }
  });

  const clearProfileRecoilStore = useEvent((): void => {
    Log.debug("landing Clear profile recoil store called");
    setIsLoggedIn(false);
    setProfileLandingDtoAtom(undefined);
  });

  return { fetchAndSetProfile, clearProfileRecoilStore };
};
